import { render, staticRenderFns } from "./ChipList.vue?vue&type=template&id=660c4052"
import script from "./ChipList.vue?vue&type=script&lang=js"
export * from "./ChipList.vue?vue&type=script&lang=js"
import style0 from "./ChipList.vue?vue&type=style&index=0&id=660c4052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports